import styled from 'styled-components';

export const StudentsPerformanceBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  padding: 36px;

  p {
    text-align: center;
    font-size: 16px;
  }
`;

export const GraphContainer = styled.div`
  height: 60px;
  margin-bottom: 32px;
`;
